import type { ModelData } from '@/shared/stores/model-utils'

export const model18InitialModel: ModelData = {
    name: 'Template 18 - Double Door With Solid Frames',
    modelId: 'model18',
    type: 'DOOR',
    description:
      '18-variant double door with solid frames and dual door opening with openable window',
    width: 3600,
    height: 2200,
    photoId: null,
    serviceNames: [],
    serviceIds: [],
    parameters: [
      {
        positionId: 'top_frame_profile',
        type: 'PROFILE',
        width: 3600,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 0, y: 0, z: 0 },
      },
      {
        positionId: 'right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2200,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 3540, y: 0, z: 0 },
      },

      {
        positionId: 'bottom_right_frame_profile',
        type: 'PROFILE',
        width: 700,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2900, y: 2140, z: 0 },
      },
      {
        positionId: 'bottom_center_frame_profile',
        type: 'PROFILE',
        width: 1280,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1620, y: 2140, z: 0 },
      },

      {
        positionId: 'double_door_bottom_frame_profile_1',
        type: 'PROFILE',
        width: 720,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 2140, z: 0 },
      },
      {
        positionId: 'double_door_bottom_frame_profile_2',
        type: 'PROFILE',
        width: 720,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 840, y: 2140, z: 0 },
      },
      {
        positionId: 'double_door_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 320, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_1_left_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 60, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 310, z: 10 },
            },
            {
              positionId: 'door_1_left_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 560, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 1350, z: 10 },
            },
            {
              positionId: 'door_1_left_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: -25, y: 1550, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'double_door_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 720, y: 320, z: 0 },
      },
      {
        positionId: 'double_door_middle_vertical_frame_profile_center',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 780, y: 320, z: 0 },
      },
      {
        positionId: 'double_door_2_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 840, y: 320, z: 0 },
        hardware: {
          handles: [
            {
              positionId: 'door_2_left_handle_1',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 5, y: 900, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'double_door_2_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 1880,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1500, y: 320, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'door_2_right_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 60, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 310, z: 10 },
            },
            {
              positionId: 'door_2_right_top_hinge_3',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 560, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1350, z: 10 },
            },
            {
              positionId: 'door_2_right_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 100,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 1550, z: 10 },
            },
          ],
        },
      },

      {
        positionId: 'double_door_1_top_frame_profile',
        type: 'PROFILE',
        width: 720,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 320, z: 0 },
      },
      {
        positionId: 'double_door_2_top_frame_profile',
        type: 'PROFILE',
        width: 720,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 840, y: 320, z: 0 },
      },

      {
        positionId: 'middle_vertical_frame_profile_center',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 1560, y: 60, z: 0 },
      },
      {
        positionId: 'double_door_middle_horizontal_frame_profile',
        type: 'PROFILE',
        width: 1500,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 60, y: 260, z: 0 },
      },
      {
        positionId: 'right_window_middle_horizontal_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 673, z: 0 },
      },
      {
        positionId: 'right_window_middle_horizontal_frame_profile_2',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 1467, z: 0 },
      },

      {
        positionId: 'right_vertical_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 2140,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2900, y: 60, z: 0 },
      },
      {
        positionId: 'top_window_1_left_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 734,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 733, z: 0 },
        hardware: {
          handles: [
            {
              positionId: 'window_vertical_handle_left',
              type: 'HORIZONTAL_HANDLE',
              width: 120,
              height: 200,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 5, y: 305, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_1_right_frame_profile',
        type: 'PROFILE',
        width: 60,
        height: 734,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 3480, y: 733, z: 0 },
        hardware: {
          hinges: [
            {
              positionId: 'top_window_1_left_top_hinge_1',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 120, z: 10 },
            },
            {
              positionId: 'top_window_1_left_bottom_hinge_2',
              type: 'HINGE',
              width: 25,
              height: 70,
              thickness: 10,
              color: '#333333',
              material: 'aluminum',
              materialId: null,
              position: { x: 60, y: 570, z: 10 },
            },
          ],
        },
      },
      {
        positionId: 'top_window_1_top_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 733, z: 0 },
      },
      {
        positionId: 'top_window_1_bottom_frame_profile',
        type: 'PROFILE',
        width: 580,
        height: 60,
        thickness: 2,
        color: '#ffffff',
        material: '',
        materialId: null,
        position: { x: 2960, y: 1407, z: 0 },
      },

      {
        positionId: 'double_door_glass_panel_1',
        type: 'GLASS',
        width: 600,
        height: 1760,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 120, y: 380, z: 0 },
      },
      {
        positionId: 'double_door_glass_panel_2',
        type: 'GLASS',
        width: 600,
        height: 1760,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 900, y: 380, z: 0 },
      },
      {
        positionId: 'center_glass_panel',
        type: 'GLASS',
        width: 1280,
        height: 2080,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 1620, y: 60, z: 0 },
      },
      {
        positionId: 'double_door_top_glass_panel',
        type: 'GLASS',
        width: 1500,
        height: 200,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 60, y: 60, z: 0 },
      },
      {
        positionId: 'right_glass_panel_top',
        type: 'GLASS',
        width: 580,
        height: 613,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 2960, y: 60, z: 0 },
      },
      {
        positionId: 'right_glass_panel_opanable',
        type: 'GLASS',
        width: 460,
        height: 614,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 3020, y: 793, z: 0 },
      },
      {
        positionId: 'right_glass_panel_bottom',
        type: 'GLASS',
        width: 580,
        height: 613,
        thickness: 6,
        color: 'rgba(255, 255, 255, 0.02)',
        material: 'clear_glass',
        materialId: null,
        isDouble: false,
        position: { x: 2960, y: 1527, z: 0 },
      },
    ],
    doorConfiguration: {
      type: 'double_door',
      totalDoorWidth: 1620,
      individualDoorWidth: [810, 810],
      totalHandles: 1,
      openingDirection: 'both_sides_opening',
      hingePosition: 'both_sides',
      leftDoorWidth: 810,
      rightDoorWidth: 810,
      centerSeparatorWidth: 60,
    },
  }
